import { useState } from "react";
import { Link } from "react-router-dom";
import { Button, Card, CardBody, Field, TextInput } from "@odingard/design-system";
import { api } from "../../lib/api";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [devLink, setDevLink] = useState<string | null>(null);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await api.forgotPassword(email);
      setDevLink(res.link ?? null);
      setSent(true);
    } catch {
      // Fail closed to the same generic confirmation (no account enumeration).
      setSent(true);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-wrap">
      <div className="auth-card">
        <Link to="/" className="brand" style={{ justifyContent: "center", marginBottom: "var(--ods-space-5)" }}>
          <span className="brand__mark">O</span> Odingard Studio
        </Link>
        <Card>
          <CardBody>
            <h1 style={{ fontSize: "var(--ods-text-xl)", marginTop: 0 }}>Reset your password</h1>
            {sent ? (
              <>
                <div className="banner banner--info" role="status">
                  If an account exists for <strong>{email}</strong>, a link to reset your password is on its way.
                </div>
                {devLink && (
                  <p style={{ fontSize: "var(--ods-text-sm)" }}>
                    Email isn&apos;t configured yet, so <a href={devLink}>reset your password now</a>.
                  </p>
                )}
              </>
            ) : (
              <form onSubmit={onSubmit}>
                <p style={{ color: "var(--ods-color-muted)", fontSize: "var(--ods-text-sm)", marginTop: 0 }}>
                  Enter your email and we&apos;ll send a link to choose a new password.
                </p>
                <Field label="Work email">
                  {(id) => (
                    <TextInput id={id} type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                  )}
                </Field>
                <Button type="submit" block disabled={busy}>
                  {busy ? "Sending…" : "Send reset link"}
                </Button>
              </form>
            )}
            <p style={{ textAlign: "center", marginBottom: 0, fontSize: "var(--ods-text-sm)", color: "var(--ods-color-muted)" }}>
              <Link to="/login">Back to sign in</Link>
            </p>
          </CardBody>
        </Card>
      </div>
    </div>
  );
}
